export default __webpack_public_path__ + "static/media/linkscourses.971ed69f.png";